import { BrandName } from '../Typescript'
import { wait } from '../Utils'
import Config from '../Data/Config.json'

class LaunchRules {
    private _brand?: BrandName
    private _devMode = false

    async init(devMode: boolean, brand = BrandName.cnbc): Promise<void> {
        this._devMode = devMode
        this._brand = brand
        const timeoutInMS = wait(5000)
        await Promise.race([this.loadAdobeScript(), timeoutInMS])
        return
    }

    private async loadAdobeScript(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const adobeLaunchLibrary = document.createElement('script')
            adobeLaunchLibrary.setAttribute('src', this.getLaunchRulesUrl())
            adobeLaunchLibrary.setAttribute('async', '')
            adobeLaunchLibrary.onload = () => resolve()
            adobeLaunchLibrary.onerror = () => reject()
            document.head.appendChild(adobeLaunchLibrary)
        })
    }

    private getLaunchRulesUrl() {
        const brand = this._brand === BrandName.cnbc ? BrandName.cnbc : BrandName.msnbc
        const mode = this._devMode ? 'dev' : 'prod'
        return Config.launchRulesUrls[brand][mode]
    }
}

export default new LaunchRules()
